import {Button} from '@primer/react'
import {clsx} from 'clsx'
import {useAutomatedReviewCommentActions} from '../hooks/use-automated-review-comment-actions'

export interface AutomatedComment {
  id: string
  isDismissed: boolean
  viewerCanDismiss: boolean
  viewerCanReopen: boolean
  source: string
}

export function BaseAutomatedReviewCommentActions({
  automatedComment,
  isButtonDisabled,
  onDismiss,
  onReopen,
  className,
}: {
  automatedComment: AutomatedComment
  isButtonDisabled: boolean
  onDismiss: (args: {reason: string; resolutionNote?: string}) => void
  onReopen: () => void
  className?: string
}) {
  const {isDismissable, isReopenable, resourceName, toggleButtonLabel} =
    useAutomatedReviewCommentActions(automatedComment)

  return (
    <>
      {isDismissable && (
        <div className={clsx('d-flex flex-items-center flex-wrap', className)}>
          <Button
            aria-label={toggleButtonLabel}
            className="mr-2"
            onClick={() => onDismiss({reason: 'wont_fix'})}
            disabled={isButtonDisabled}
          >
            {toggleButtonLabel}
          </Button>
          <span className="fgColor-muted f6">
            Dismissing the {resourceName} will mark this conversation as resolved.
          </span>
        </div>
      )}
      {isReopenable && (
        <div className={clsx('d-flex flex-items-center flex-wrap', className)}>
          <Button aria-label={toggleButtonLabel} onClick={onReopen} disabled={isButtonDisabled}>
            {toggleButtonLabel}
          </Button>
        </div>
      )}
    </>
  )
}

try{ BaseAutomatedReviewCommentActions.displayName ||= 'BaseAutomatedReviewCommentActions' } catch {}